<script setup>
import { ref, watch } from 'vue';
import _ from 'lodash';
import TransformImplementationFlow from './TransformImplementationFlow.vue';

const props = defineProps(['transform']);

let transform = ref(null);
let defaultTransform = ref('');

// Watch for changes in the transform prop
watch(
    () => props.transform,
    (newTransform) => {
        if (newTransform?.id) {
            transform.value = newTransform;
            defaultTransform.value = _.cloneDeep(newTransform);
        }
    },
    { immediate: true }
);
</script>

<template>
    <div class="mt-3 w-full">
        <div v-if="!transform?.id" class="text-center py-8">
            <p>Waiting for transform data...</p>
            <p class="text-sm text-muted-foreground">Transform prop: {{ !!props.transform }}, ID: {{ props.transform?.id }}</p>
        </div>
        <TransformImplementationFlow v-else-if="transform?.id" :transformId="transform.id" />
    </div>
</template>

<style></style>
